import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LeadService, SendPstNotificationResponse, UIConfiguration, Student } from '../../lib';


@Injectable({
  providedIn: 'root'
})
export class PSTService {
  PSTEnabled: boolean | undefined;
  PSTLabel: string = '';
  PSTFailurePopupShow: boolean = false;
  PSTSMSAllowed: boolean = false;
  PSTEmailAllowed: boolean = false;
  PSTSMSDisabled: boolean = false;
  PSTEmailDisabled: boolean = false;

  private PSTSMSAttempts: number | undefined;
  private PSTSMSDelay: number | undefined;
  private PSTEmailAttempts: number | undefined;
  private PSTEmailDelay: number | undefined;
  public pstConnectedDuration: number = 0;

  constructor(private readonly leadService: LeadService) { }

  initializePSTConfiguration(uiConfiguration: UIConfiguration[], studentData: Student | undefined) {
    this.PSTEnabled = uiConfiguration?.find(obj => obj.key === 'PST.Enable')?.value === '1';
    this.PSTLabel = uiConfiguration?.find(obj => obj.key === 'PST.Label')?.value ?? this.PSTLabel;
    this.PSTFailurePopupShow = uiConfiguration?.find(obj => obj.key === 'PST.FailurePopup.Show')?.value === '1';
    this.PSTSMSAllowed = uiConfiguration?.find(obj => obj.key === 'PST.SMS.Enable')?.value === '1';
    this.PSTEmailAllowed = uiConfiguration?.find(obj => obj.key === 'PST.Email.Enable')?.value === '1';

    this.PSTSMSAttempts = parseInt(uiConfiguration?.find(obj => obj.key === 'PST.SMS.Attempts')?.value || '0');
    this.PSTSMSDelay = parseInt(uiConfiguration?.find(obj => obj.key === 'PST.SMS.Delay')?.value || '0');
    this.PSTEmailAttempts = parseInt(uiConfiguration?.find(obj => obj.key === 'PST.Email.Attempts')?.value || '0');
    this.PSTEmailDelay = parseInt(uiConfiguration?.find(obj => obj.key === 'PST.Email.Delay')?.value || '0');
    this.pstConnectedDuration = parseInt(uiConfiguration?.find(obj => obj.key === 'PST.ConnectedDurationSeconds')?.value || '0');

    if (this.PSTSMSAttempts && this.PSTSMSAttempts <= 0) {
      this.PSTSMSDisabled = true;
    }

    if (this.PSTEmailAttempts && this.PSTEmailAttempts <= 0) {
      this.PSTEmailDisabled = true;
    }
  }

  startSMSDisabledTimer(callback: () => void) {
    if (this.PSTSMSDelay) {
      let timer = this.PSTSMSDelay;
      const interval = setInterval(() => {
        timer--;
        if (timer <= 0) {
          clearInterval(interval);
          callback();
        }
      }, 1000);
    }
  }

  startEmailDisabledTimer(callback: () => void) {
    if (this.PSTEmailDelay) {
      let timer = this.PSTEmailDelay;
      const interval = setInterval(() => {
        timer--;
        if (timer <= 0) {
          clearInterval(interval);
          callback();
        }
      }, 1000);
    }
  }

  sendPSTNotification(studentId: number, sendType: 'SMS' | 'Email'): Observable<SendPstNotificationResponse> {
    return this.leadService.apiLeadSendPSTNotificationPost({ studentId: String(studentId), sendType });
  }

  isMaxSMSAttemptsReached(totalSMSAttempts: number): boolean {
    return this.PSTSMSAttempts !== undefined && totalSMSAttempts >= this.PSTSMSAttempts;
  }

  isMaxEmailAttemptsReached(totalEmailAttempts: number): boolean {
    return this.PSTEmailAttempts !== undefined && totalEmailAttempts >= this.PSTEmailAttempts;
  }
}
